import apiService from './api/apiService';
import { toast } from 'react-toastify';

const hotelId = localStorage.getItem('hotel');

const statusMap = {
  in_progress: 'In-progress',
  out_of_order: 'Out of Order',
  clean: 'Clean',
  dirty: 'Dirty',
};

export const formatStatus = status => {
  return (
    statusMap[status] ||
    status
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
};

export const updateRoomStatus = async (room, bookingStatus) => {
  try {
    const newStatus = bookingStatus === 'confirmed' ? 'occupied' : 'available';

    // Only update if the room's current status is different
    if (room.status !== newStatus) {
      const updatedRoomStatus = { status: newStatus };
      await apiService.patch(
        `/rooms/${room.id}/?hotel=${hotelId}`,
        updatedRoomStatus
      );
      onSuccess();

      console.log(`Room ${room.room_number} status updated to ${newStatus}`);

      // Show toast notification after successful update
      setTimeout(() => {
        toast.success(
          `Room ${room.room_number} status updated to ${
            newStatus.charAt(0).toUpperCase() + newStatus.slice(1)
          }!`
        );
      }, 500);
    } else {
      console.log(
        `Room ${room.room_number} status is already up to date, no patch needed.`
      );
    }
  } catch (error) {
    console.error(`Failed to update room ${room.room_number} status:`, error);
    toast.error(`Failed to update room ${room.room_number} status!`);
  }
};

export function getRoomNumberById(roomsArray, id) {
  const room = roomsArray.find(item => item.id === id);
  return room ? room.room_number : 'NA';
}
